import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import './Forms.css';

const ServiceDropdown = ({ selectedServices, onServiceChange }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const services = [
    'Office and Warehouse LED Lighting',
    'Commercial Electrical Wiring', 
    'Communications', 
    'Panel & Sub-panel Replacement and Upgrades', 
    'Electrical Panel Upgrades', 
    'Electrical Repair Services', 
    'Indoor Lighting', 
    'Electrical Vehicle Charger Installation',
    'Other (smaller jobs e.g., Add Outlet, etc)'
  ];

  const handleCheckboxChange = (service) => {
    onServiceChange(service);
  };

  const selectedStyle = {
    backgroundColor: '#535B6F',
    color: '#fff',
    border: '1px solid #000',
    // other styles
  };

  return (
    <div className="service-dropdown">
      <div className="dropdown-menu">
          {services.map(service => (
            <div key={uuidv4()} style={selectedServices.includes(service) ? selectedStyle : {}}>
              <input
                className='checked'
                type="checkbox"
                id={service}
                checked={selectedServices.includes(service)}
                onChange={() => handleCheckboxChange(service)}
              />
              <label className='options' htmlFor={service}>{service}</label>
            </div>
          ))}
        </div>
    </div>
  );
};

export default ServiceDropdown;